module.exports = __webpack_public_path__ + "img/doctor-3.280b16ed.png";